module.exports = __webpack_public_path__ + "static/media/realtors-icon-1.8dd2bcad.svg";